/**
 * Language ids matching backend LanguageEnum (Kuba2.Data.Entities/Shared/Enums/LanguageEnum.cs)
 */
export enum LanguageId {
  English = 1,
  Norwegian = 2,
  Swedish = 3
}
